import { render, staticRenderFns } from "./RepositionOrdersForm.vue?vue&type=template&id=3a962a33&scoped=true&"
import script from "./RepositionOrdersForm.vue?vue&type=script&lang=js&"
export * from "./RepositionOrdersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a962a33",
  null
  
)

export default component.exports